module.exports = __webpack_public_path__ + "static/media/bolsaProtegida.64270a89.svg";